import { useMemo } from "react";

const counters = new Map<string, number>();

interface IUseUniqueIdOptions {
    type?: "random" | "sequential";
    prefix?: string;
    separator?: string;
}

export const resetAllCounters = () => {
    counters.clear();
};

export const useUniqueId = (options: IUseUniqueIdOptions = {}): string => {
    const { type = "sequential", prefix = "frmnt", separator = "_" } = options;
    return useMemo(() => {
        let id;
        switch (type) {
            case "sequential": {
                const next = counters.get(prefix) ?? 0;
                counters.set(prefix, next + 1);
                id = next.toString(36);
                break;
            }
            case "random": {
                id = Math.random().toString(36).substring(2).padStart(12, "0");
                break;
            }
            default:
                throw new Error(`unsupported type: ${type}`);
        }
        return `${prefix}${separator}${id}`;
    }, [type, prefix]);
};
